import DisclosureNotes from "./disclosureNotes"

export default DisclosureNotes
